import { version } from "./version";

export const environment = {
  production: true,
  version,
};
